import React from 'react';
import { Button } from '@/components/ui/button';
import { Search, ArrowRight } from 'lucide-react';

export default function IntroScreen({ onStart }) {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="w-full border-b border-border bg-background">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center">
            <Search className="w-5 h-5 text-primary-foreground" />
          </div>
          <span className="font-semibold text-foreground">Diagnostic Pro</span>
        </div>
      </header>

      {/* Main content */}
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-2xl w-full animate-fade-in">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-muted text-primary text-sm font-medium mb-8">
            <Search className="w-4 h-4" />
            <span>Diagnostic en 22 questions</span>
          </div>

          {/* Title */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-foreground leading-tight mb-8">
            Diagnostic – Conciergerie & Sous-location
          </h1>

          {/* Introduction text */}
          <div className="space-y-6 text-base sm:text-lg text-muted-foreground leading-relaxed mb-12">
            <p>
              La plupart des projets en conciergerie ou en sous-location ne stagnent pas par manque d&apos;envie ou de potentiel.
              <span className="text-foreground font-medium"> Ils stagnent parce que l&apos;activité n&apos;est pas structurée comme une entreprise.</span>
            </p>
            
            <p>
              Ce diagnostic a été conçu pour faire une chose simple : <span className="text-foreground font-medium">identifier précisément ce qui te freine aujourd&apos;hui</span>, que tu sois en phase de lancement, de croissance lente ou déjà actif mais sous pression.
            </p>
            
            <p>
              Il ne s&apos;agit pas d&apos;un test, ni d&apos;un audit commercial. C&apos;est un outil de lecture claire, basé uniquement sur tes réponses.
            </p>
            
            <p className="text-sm border-l-2 border-primary pl-4 py-2 bg-primary-muted/50 rounded-r-md">
              Selon ton volume et ta situation, tu peux être orienté vers un diagnostic plus approfondi. Ce n&apos;est pas une question de niveau, mais d&apos;enjeux réels.
            </p>
          </div>

          {/* CTA Button */}
          <Button 
            onClick={onStart}
            size="lg"
            className="group"
          >
            Commencer le diagnostic
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </Button>
        </div>
      </div>

      {/* Footer */}
      <footer className="w-full border-t border-border bg-background">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <p className="text-sm text-muted-foreground">
            Temps estimé : 5 à 8 minutes
          </p>
        </div>
      </footer>
    </div>
  );
}